export type GlobalSettingKey = "manage_intro_video_url" | "portal_intro_video_url";

export type GlobalSettings = Record<GlobalSettingKey, string | null>;

export interface GlobalSettingDefinition {
  key: GlobalSettingKey;
  settingLabelKey: string;
  portalLabelKey: string;
}

export interface GlobalSettingRow extends GlobalSettingDefinition {
  value: string | null;
}

export const GLOBAL_SETTING_DEFINITIONS: readonly GlobalSettingDefinition[] = [
  {
    key: "manage_intro_video_url",
    settingLabelKey: "intro_video",
    portalLabelKey: "kaer_manager_portal_name",
  },
  {
    key: "portal_intro_video_url",
    settingLabelKey: "intro_video",
    portalLabelKey: "kaer_employee_portal_name",
  },
];

export const buildGlobalSettingRows = (
  settings: GlobalSettings,
): GlobalSettingRow[] =>
  GLOBAL_SETTING_DEFINITIONS.map((definition) => ({
    ...definition,
    value: settings[definition.key] ?? null,
  }));
